import { c as _c } from "react/compiler-runtime";
import type { ChangelogPost } from '@onefootprint/changelog';
import { isAfter } from 'date-fns';
import { useLocalStorage } from 'usehooks-ts';
const LAST_SEEN_KEY = 'whatsNewLastSeenAt';

// `posts` arrive newest first, so the first one decides whether anything is unseen.
const useChangelogPosts = posts => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      initializeWithValue: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [lastSeenAt, setLastSeenAt] = useLocalStorage(LAST_SEEN_KEY, "", t0);
  const newestAt = posts[0]?.publishedAt;
  let t1;
  if ($[1] !== lastSeenAt || $[2] !== newestAt) {
    t1 = !!newestAt && (!lastSeenAt || isAfter(newestAt, lastSeenAt));
    $[1] = lastSeenAt;
    $[2] = newestAt;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hasUnseenPosts = t1;
  let t2;
  if ($[4] !== newestAt || $[5] !== setLastSeenAt) {
    t2 = () => {
      if (newestAt) {
        setLastSeenAt(newestAt);
      }
    };
    $[4] = newestAt;
    $[5] = setLastSeenAt;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const markSeen = t2;
  let t3;
  if ($[7] !== hasUnseenPosts || $[8] !== markSeen) {
    t3 = {
      hasUnseenPosts,
      markSeen
    };
    $[7] = hasUnseenPosts;
    $[8] = markSeen;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default useChangelogPosts;